<app-svg-icon name="copy-small" />
